const networks = {
  "0x1": "Mainnet",
  "0x1e808f": "XPhere-Testnet",
}

export { networks };
